import React, { useEffect, useRef } from "react";
import ImgCrop from "antd-img-crop";
import { CrossIcon } from "../svgV2/CrossIcon";

const ImageCropModalStyles = () => (
  <style>{`
    @keyframes waCropModalFadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes waCropModalFadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }

    .image-crop-modal .ant-zoom-enter,
    .image-crop-modal .ant-zoom-appear {
      opacity: 0 !important;
      transform: none !important;
    }
    .image-crop-modal .ant-zoom-enter.ant-zoom-enter-active,
    .image-crop-modal .ant-zoom-appear.ant-zoom-appear-active {
      animation-name: waCropModalFadeIn !important;
      animation-duration: 0.2s !important;
      animation-timing-function: ease-out !important;
      transform: none !important;
    }
    .image-crop-modal .ant-zoom-leave.ant-zoom-leave-active {
      animation-name: waCropModalFadeOut !important;
      animation-duration: 0.15s !important;
      animation-timing-function: ease-in !important;
      transform: none !important;
    }
  `}</style>
);

const ImageCropModal = ({ children, cropShape }) => {
  const draggingRef = useRef(false);

  useEffect(() => {
    const onMouseDown = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Any drag that starts on a slider (zoom/rotation) or inside the
      // crop modal's content area is a real interaction, not a mask click.
      draggingRef.current = !!target.closest(
        ".ant-slider, .img-crop-control, .ant-modal-content"
      );
    };

    const onMouseUp = () => {
      // Reset shortly after mouseup, AFTER the click handler below runs
      // (click fires right after mouseup, synchronously, in the same tick).
      setTimeout(() => {
        draggingRef.current = false;
      }, 0);
    };

    // Capture phase, at document level — runs before antd's wrapper
    // onClick (attached via React's delegated root listener) ever sees it.
    const onClickCapture = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isWrapperClick = target.classList?.contains("ant-modal-wrap");
      if (draggingRef.current && isWrapperClick) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    document.addEventListener("mousedown", onMouseDown, true);
    document.addEventListener("mouseup", onMouseUp, true);
    document.addEventListener("click", onClickCapture, true);
    return () => {
      document.removeEventListener("mousedown", onMouseDown, true);
      document.removeEventListener("mouseup", onMouseUp, true);
      document.removeEventListener("click", onClickCapture, true);
    };
  }, []);

  return (
    <>
      <ImageCropModalStyles />
      <ImgCrop
        cropShape={cropShape}
        rotationSlider
        modalClassName="image-crop-modal"
        modalOk="Crop"
        modalProps={{ closeIcon: <CrossIcon /> } as any}
        modalTitle={
          (<div className="out-500-16 text-black">Crop your image</div>) as any
        }
      >
        {children}
      </ImgCrop>
    </>
  );
};

export default ImageCropModal;